import React from "react";
import { RKAS } from "../../../containers";
const Rkas = (props) => {
  return <RKAS {...props} />;
};

export default Rkas;
